export const ResourceFields = `
{
    url
    body
}

`;
